var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResourcePdf = function SvgResourcePdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.resource_pdf_st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EF2B2B;fill-opacity:0.5;}\r\n\t.resource_pdf_st1{fill:#FFFFFF;}\r\n\t.resource_pdf_st2{fill-rule:evenodd;clip-rule:evenodd;fill:#E6E7E8;}\r\n\t.resource_pdf_st3{fill-rule:evenodd;clip-rule:evenodd;fill:#EF2B2B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDF_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "resource_pdf_st0",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(32.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "resource_pdf_st1",
    d: "M63.8,72.4c0,3.8-3,6.8-6.8,6.8H9.7c-3.7,0-6.8-3-6.8-6.8V6.8C2.9,3,5.9,0,9.7,0h30.5v18.1 c0,3.1,2.5,5.7,5.6,5.7h18.1V72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1_",
    className: "resource_pdf_st2",
    d: "M42.3,0.2l21.6,21.2H46.5c-2.4,0-4.3-1.9-4.3-4.3V0.2L42.3,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2_",
    className: "resource_pdf_st3",
    d: "M1.7,44h44.6c0.9,0,1.7,0.8,1.7,1.7v18.6c0,0.9-0.8,1.7-1.7,1.7H1.7C0.8,66,0,65.2,0,64.3 V45.7C0,44.8,0.8,44,1.7,44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PDF",
    className: "resource_pdf_st1",
    d: "M11.9,60v-3.8h2.8c2.3,0,3.6-1.6,3.6-3.5c0-1.9-1.3-3.5-3.6-3.5H9.6V60H11.9z M14.3,54.1h-2.4v-2.9 h2.4c0.9,0,1.6,0.6,1.6,1.5C15.9,53.6,15.2,54.1,14.3,54.1z M23.9,60c3.4,0,5.7-2.1,5.7-5.4s-2.3-5.4-5.7-5.4h-4.3V60H23.9z  M23.9,58h-2v-6.8h2c2.2,0,3.4,1.5,3.4,3.4C27.3,56.4,26.1,58,23.9,58z M33.6,60v-4.5h5.2v-2h-5.2v-2.3H39v-2h-7.6V60H33.6z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResourcePdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resource_pdf.187eb8e9.svg";
export { ForwardRef as ReactComponent };